import React,{Component}  from "react";
import './FoldingTable.css'
import moment from 'moment'; 
import humanizeDuration from "humanize-duration";
import Dom from '../../../../helpers/Dom';

const shortEnglishHumanizer = humanizeDuration.humanizer({
    language: "shortEn",
    languages: {
      shortEn: {
        y: () => "y",
        mo: () => "mo",
        w: () => "w",
        d: () => "d",
        h: () => "h",
        m: () => "m",
        s: () => "s",
        ms: () => "ms",
      },
    },
  });

export default class FoldingTable extends Component{

    constructor(props){
        super(props)
        this.state={
            openChild:false,
            openBoxID:[],
            tableData: this.props.data.slice(0, 100),
            pageNo:1
        }   
    }
    chipBox=(data)=>{
        let chipContent = [];
        let head = [
                        { key:'date', name:'Date'},
                        { key:'vehicletype', name:'Vehicle Type'},
                        { key: "ordertype", name: "Order Type" },
                        { key: "count", name: "Order Count" },
                        { key: "duration", name: "Duration" },
                        { key: "distance", name: "Distance (km)" },
                        { key: "kmpl", name: "Mileage (kmpl)" },
                        { key: "avgspeed", name: "Avg Speed (km)" },
                        { key: "drivingtime", name: "Driving Time" },
                        { key:'idlingtime', name:'Idling Time'},
                        { key:'waitingtime', name:'Waiting Time'},
                        { key: "cost", name: "Rider Cost(Rs)" },
                        { key: "earning", name: "Earning(Rs)" },
                        { key: "netearning", name: "Net Earnings (Rs)" },
                      ];
         

    for(let i=0; i<=head.length-1; i++){
        chipContent.push(
    <div id={"chip"+i} className="chipContainer">
        <div className="chipColor"></div>
        <div className="chipData">
            <span className="spanHead">{head[i].name}</span>
            <span className="spanData">{data[head[i].key]}</span>
        </div>

    </div>
        )
    }
    return chipContent

    }

    openChildBox=(i,e)=>{
        if(!this.state.openBoxID.includes(i)){
        this.setState({openChild: true,id:i,openBoxID: [...this.state.openBoxID, i]})
        }else{
            const index = this.state.openBoxID.indexOf(i);
            if (index > -1) {
            this.setState({...this.state.openBoxID.splice(index, 1)})
            }
        }

    }
    childChipBox=(data,ind)=>{
        let orderContainer = []
        let head = [
            { key:'date', name:'Date'},
            { key: "distance", name: "Distance (km)" },
            { key: "speed", name: "Speed (km)" },
            { key: "drivingtime", name: "Driving Time" },
            { key:'idlingtime', name:'Idling Time'},
            { key:'waitingtime', name:'Waiting Time'},
            { key: "orderduration", name: "Duration" },
            { key: "ordertype", name: "Order Type" },
            { key:'orderassignmentat', name:'Assign At'},
            { key: "orderpickupat", name: "Pickedup At" },
            { key: "orderdeliveryat", name: "Delivered At" },
            { key: "orderearning", name: "Earning(Rs)" },
          ];

    for(let j=0; j<= head.length-1; j++){  
        orderContainer.push(
            <div className="childChip" id={"childChip"+j} key={j}>
                <div className="childChipColor"></div>
                    <div className="childChipData">
                    <span className="childspanHead">{head[j].name}</span>
                    <span className="childspanData">{data[[head[j].key]]}</span>
                </div>
            </div>)
        }
        return orderContainer
            }


    getChildContainer=(data)=>{
        let containerArr =[]
            for(let i = 0; i<= data.length-1; i++){
                containerArr.push(
                            <div id={"chieldChip"+i} className="childBoxContainer" key={i}>
                            <div className="childBoxReport">
                                <div className="childBoxMeta">
                                    <div className="childBoxNos">{i+1}</div>
                                </div>
                            <div className="childBoxState">
            
                {this.childChipBox(data[i])}

                </div>
                </div>
                </div>
                    )
                }
                return containerArr

                    }

    onSearch = (key)=>{
        let data = this.props.data
        let filterData = [];
       if(key.length >= 2){
        for(let idx in  data){
            if(data[idx].deid.toString().includes(key) ||
            data[idx].vehicleno.includes(key.toUpperCase()) ||
            (data[idx].vehicletype && data[idx].vehicletype.includes(key))){
                filterData.push(data[idx])
            }
        }

this.setState({tableData:filterData})
    }else{
        this.setState({tableData:this.props.data.slice(0, 100),pageNo:1})

    }

    }

    searchVehicle = ()=>{
        return(
            <div className="SearchBox" style={{ borderRadius:6}}>
			<i className="fal fa-search"></i>
			<input
				type="text"
				placeholder='Search for vehicle'
				onChange={(e) => this.onSearch(e.target.value)}
				style={{ borderRadius:6}}
			/>
		</div>
        )
    }

    getSelectedPage = (pageNo,j)=>{
        let endPosition = pageNo*100
        let startPosition = ((pageNo*100) -100)
        let sliceData = [];
        sliceData = this.props.data.slice(startPosition, endPosition)
        this.setState({tableData:sliceData, pageNo: pageNo})
    }

    goNext = ()=>{
        let noOfPage = Math.ceil(this.props.data.length/100)
        let pageNo = this.state.pageNo
        if(pageNo<noOfPage){
         pageNo = this.state.pageNo+1
        }
        let endPosition = pageNo*100
        let startPosition = ((pageNo*100) -100)
        let sliceData = [];
        sliceData = this.props.data.slice(startPosition, endPosition)
        this.setState({tableData:sliceData, pageNo: pageNo})
    }

    goPrev = ()=>{
        let pageNo = this.state.pageNo
        if(pageNo>1){
         pageNo = this.state.pageNo-1
        }
        let endPosition = pageNo*100
        let startPosition = ((pageNo*100) -100)
        let sliceData = [];
        sliceData = this.props.data.slice(startPosition, endPosition)
        this.setState({tableData:sliceData, pageNo: pageNo})
    }

    pagination = ()=>{
        let propsData = this.props.data
        let  limit = 100
        let pageNumbers = []
        let noOfPage = Math.ceil(propsData.length/100)
        for(let i=1; i<=Math.ceil(propsData.length/100); i++){
            pageNumbers.push(i)
        }

        if(pageNumbers.length>10){
            
        }       
        return(
            <div className="pagination">
  <a onClick={()=>this.goPrev()} href="#">&laquo;</a>
  {pageNumbers.map((i,j)=>{
      return(
  <a className={Dom.Class({'active':i===this.state.pageNo})} id={j+'page'} onClick={()=>this.getSelectedPage(i,j)} href="#" >{i}</a>)})
    }

  <a onClick={()=>this.goNext()} href="#">&raquo;</a>
</div>
        )
    }

    tableBoxContainer = ()=>{
        let tableBox = []
        let data = this.state.tableData
        for(let i=0; i<= data.length-1;i++){
    tableBox.push(
        <div className="tableBox" id={i} key={i}>
            <div className="boxReport" id={"report"+i}>
             <div className="leftBox">
                 <div className="boxNos">{i+1}</div>
                 <div className="vehicleInfo">
                     <ul>
                         <li id={"item"+i} className="firstItem">
                            {data[i].vehicleno}
                         </li>
                         <li className="secItem">
                            {data[i].deid}
                         </li>
                     </ul>
                 </div>
                 </div>

             <div className="rightBox" onClick={(e)=>this.openChildBox(i,e)}>
                 {this.chipBox(data[i])}
                </div>    
</div>
{this.state.openChild && this.state.openBoxID.includes(i) ?

<div id={"child"+i} className="childBoxOne">
    
        {this.getChildContainer(data[i].orders)}
   
</div>:null}
        </div>
    )
        }
return tableBox

    }

    render(){
        return(
<div className="ft-container">
    <div className="table-container">
    {this.tableBoxContainer()}
    </div>
    <div className="footer">
        <div className="search-container">
        {this.searchVehicle()}
        </div>
      <div className="pagination-container">
    {this.pagination()}
    </div>
    <div className="currentPage">
       {this.state.pageNo +' | '+ Math.ceil(this.props.data.length/100)}
    </div>
    </div>
    </div>
        )
    }
}